import React from 'react'
import '../../scss/header.scss'

export default function Header(): React.ReactElement {
	return (
		<div className="container menu">
			<div className="inline-img">
				<img src="/assets/img/logos/logo.png" alt="Brandtech" title="Brandtech" />
			</div>
		</div>
	)
}
